import { BotTemplates, TriggerCreate } from "@dots-projects/types";
import { message } from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { getSupaClient } from "../../lib/supabase";

type BotData = {
  name: string;
  trigger: TriggerCreate;
  id: number;
  description: string;
  details_html: string;
  gif_url: string;
  slug: string;
  tags: string;
  emoji: string;
} | null;

const fetchBotData = async (
  name: string,
  workspace: string
): Promise<BotData> => {
  const supabase = getSupaClient();
  const { data, error } = await supabase
    .from<BotTemplates>("bot_templates")
    .select("*")
    .eq("slug", name);

  if (error || data.length === 0) {
    return null;
  }
  const template = data[0];
  const triggerString = JSON.stringify(template.trigger);
  const trigger = JSON.parse(triggerString);
  return {
    ...template,
    name: template.name.replace(" Discord Bot", ""),
    trigger: {
      ...trigger,
      communityId: localStorage.getItem("guild-id") || "",
      authorUserId: localStorage.getItem("discord-id") || "",
      workspace,
    } as TriggerCreate,
  };
};

export function useBotTemplateData(name: string, workspace: string) {
  return useQuery(["bot-template", name], () => fetchBotData(name, workspace));
}

export default function useDiscordBotTemplates() {
  const supabase = getSupaClient();
  const [botTemplates, setBotTemplates] = useState<BotTemplates[]>([]);

  useEffect(() => {
    loadsBotTemplates();
  }, []);

  // Loads bot templates
  const loadsBotTemplates = async () => {
    let { data, error } = await supabase
      .from<BotTemplates>("bot_templates")
      .select("*");
    if (error) {
      message.error("Try again");
    }
    if (data) {
      data = data.map((item) => ({
        ...item,
        name: item.name.replace(" Discord Bot", ""),
      }));
      setBotTemplates(data);
    }
  };

  return {
    botTemplates,
  };
}
